// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2716%27 height=%2716%27 viewBox=%270 0 16 16%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Crect width=%2716%27 height=%2716%27 fill=%27%23fff%27/%3E%3Crect x=%270%27 y=%270%27 width=%278%27 height=%278%27 fill=%27%23ccc%27/%3E%3Crect x=%278%27 y=%278%27 width=%278%27 height=%278%27 fill=%27%23ccc%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.control-wrapper {
  container-type: inline-size;
}

.control {
  padding: 16px;
  border-style: solid;
  border-width: 0 0 1px 0;
  border-bottom-color: rgb(195, 195, 195);
  background-color: white;
  /* ensure this stays */
  cursor: default;
  ;
}

.children {
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  width: 100%;
  /* fill the .control container */
}

.label-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  min-width: 0;
  /* Allow shrinking below content min-size */
}

.label-row>label {
  font-size: 18px;
  font-weight: 700;
  min-width: 100px;
}

.label-row>span {
  min-width: 36px;
  font-size: 12pt;
  text-align: center;
}

.label-row>input {
  max-width: 95px;
}

.input-row {
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex: 1;
  align-items: center;
}

.input-row>input,
.input-row>select {
  flex: 1 1 auto;
  width: 100%;
  min-width: 0;
}

.input-row>button {
  flex: 0 0 auto;
  margin-left: 8px;
}

/* styles.css or styles.module.css */
/* styles.css or styles.module.css */
.checkerboard {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 24px 24px;
  padding: 4px;
  display: inline-block;
}

/* Small screen */
@container (max-width: 450px) {
  .children {
    flex-direction: column;
    gap: 8px;
    align-items: stretch;
    width: 100%;
    /* ensure full width */
  }

  .label-row>input {
    max-width: 100%;
  }

  .label-row,
  .input-row {
    width: 100%;
    /* fill container to show background */
  }

  .label-row {
    justify-content: space-between;
    /* Heading | Value */
  }

  .input-row {
    justify-content: flex-start;
    /* Input | Reset | Tooltip */
  }
}

/* New addition: Make the output input in .label-row flexible, shrinkable, and truncate with ellipsis */
.label-row>input {
  flex: 1 1 0px;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  /* Ensure no wrapping (though default for inputs) */
}`, "",{"version":3,"sources":["webpack://./src/components/control/control.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;;AAEjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,OAAO;EACP,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC,oCAAoC;AACpC;EACE,yDAAiT;EACjT,0BAA0B;EAC1B,YAAY;EACZ,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE;IACE,sBAAsB;IACtB,QAAQ;IACR,oBAAoB;IACpB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,sCAAsC;EACxC;;EAEA;IACE,8BAA8B;IAC9B,oBAAoB;EACtB;;EAEA;IACE,2BAA2B;IAC3B,4BAA4B;EAC9B;AACF;;AAEA,uGAAuG;AACvG;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,mDAAmD;AACrD","sourcesContent":[".control-wrapper {\n  container-type: inline-size;\n}\n\n.control {\n  padding: 16px;\n  border-style: solid;\n  border-width: 0 0 1px 0;\n  border-bottom-color: rgb(195, 195, 195);\n  background-color: white;\n  /* ensure this stays */\n  cursor: default;\n  ;\n}\n\n.children {\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n  align-items: center;\n  width: 100%;\n  /* fill the .control container */\n}\n\n.label-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  /* Allow shrinking below content min-size */\n}\n\n.label-row>label {\n  font-size: 18px;\n  font-weight: 700;\n  min-width: 100px;\n}\n\n.label-row>span {\n  min-width: 36px;\n  font-size: 12pt;\n  text-align: center;\n}\n\n.label-row>input {\n  max-width: 95px;\n}\n\n.input-row {\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n  flex: 1;\n  align-items: center;\n}\n\n.input-row>input,\n.input-row>select {\n  flex: 1 1 auto;\n  width: 100%;\n  min-width: 0;\n}\n\n.input-row>button {\n  flex: 0 0 auto;\n  margin-left: 8px;\n}\n\n/* styles.css or styles.module.css */\n/* styles.css or styles.module.css */\n.checkerboard {\n  background-image: url(\"data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='16' height='16' fill='%23fff'/%3E%3Crect x='0' y='0' width='8' height='8' fill='%23ccc'/%3E%3Crect x='8' y='8' width='8' height='8' fill='%23ccc'/%3E%3C/svg%3E\");\n  background-size: 24px 24px;\n  padding: 4px;\n  display: inline-block;\n}\n\n/* Small screen */\n@container (max-width: 450px) {\n  .children {\n    flex-direction: column;\n    gap: 8px;\n    align-items: stretch;\n    width: 100%;\n    /* ensure full width */\n  }\n\n  .label-row>input {\n    max-width: 100%;\n  }\n\n  .label-row,\n  .input-row {\n    width: 100%;\n    /* fill container to show background */\n  }\n\n  .label-row {\n    justify-content: space-between;\n    /* Heading | Value */\n  }\n\n  .input-row {\n    justify-content: flex-start;\n    /* Input | Reset | Tooltip */\n  }\n}\n\n/* New addition: Make the output input in .label-row flexible, shrinkable, and truncate with ellipsis */\n.label-row>input {\n  flex: 1 1 0px;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  /* Ensure no wrapping (though default for inputs) */\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
